import React from "react";
import * as Sentry from "@sentry/react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router";

function getEnvString(value: string | undefined): string | undefined {
  const trimmed = value?.trim();
  return trimmed ? trimmed : undefined;
}

function getEnvBoolean(value: string | undefined, defaultValue: boolean): boolean {
  if (!value) return defaultValue;
  return value.toLowerCase() === "true";
}

function getEnvNumber(value: string | undefined, defaultValue: number): number {
  if (!value) return defaultValue;

  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : defaultValue;
}

const dsn = getEnvString(import.meta.env.VITE_SENTRY_DSN);

export const sentryEnabled = Boolean(dsn) && getEnvBoolean(import.meta.env.VITE_SENTRY_ENABLED, true);

if (sentryEnabled) {
  Sentry.init({
    dsn,
    environment: getEnvString(import.meta.env.VITE_SENTRY_ENVIRONMENT) ?? import.meta.env.MODE,
    debug: import.meta.env.DEV,
    sendDefaultPii: getEnvBoolean(import.meta.env.VITE_SENTRY_SEND_DEFAULT_PII, false),
    tracesSampleRate: getEnvNumber(
      import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE,
      import.meta.env.DEV ? 1 : 0.1
    ),
    integrations: [
      Sentry.reactRouterV7BrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],
  });
}
